import BaseTransformer from "./base.transformer"
export const baseUri = "/api/payment-sources"

const types = {
  0: "card",
  1: "paypal"
}

function getCardInfo(cardInfo) {
  return cardInfo
    ? {
        ...cardInfo,
        last4: `${cardInfo?.last4}`
      }
    : null
}

function getCustomerInfo({ customerId, name } = {}) {
  let _customerInfo = customerId || name ? {} : null

  if (name) _customerInfo[name] = name

  if (customerId) _customerInfo[customerId] = customerId

  return _customerInfo
}

class PaymentSourceTransformer extends BaseTransformer {
  static fetch(item) {
    const uuid = this.transformUuid(item)
    let source = {
      uuid,
      iri: this.uuidToIri(baseUri, uuid),
      customerInfo: types[item.type] == "paypal" ? getCustomerInfo(item.info) : null,
      cardInfo: types[item.type] == "card" ? getCardInfo(item.info?.card) : null,
      pm: item.info?.pm,
      isDefault: item.isDefault,
      type: types[item.type],
      client_secret: item.info?.client_secret
    }
    return this.removeEmptyProps(source)
  }
}

export default PaymentSourceTransformer
